import { Component, Input } from '@angular/core';

import { DigitisationStatus } from '®shared/list-item';
import { Permissions, UserPermissions } from '®shared/permissions';
import { EditableItem } from '®shared/reading-list/models';

import { AppConfig } from '../config';

@Component({
  selector: 'rl-course-reserve-status',
  templateUrl: './course-reserve-status.component.html',
})
export class CourseReserveStatusComponent {
  @Input() permissions?: UserPermissions;
  @Input() item: EditableItem;

  DigitisationStatus = DigitisationStatus;

  constructor(private appConfig: AppConfig) {}

  get isCourseReserveWorkflowEnabled() {
    return Boolean(
      this.appConfig.tenant.featureFlags.isCourseReserveWorkflowEnabled,
    );
  }

  get hasRequestCourseReservePermission(): boolean {
    return this.permissions?.hasPermission(Permissions.REQUEST_COURSE_RESERVE);
  }
}
